import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

import OnTraccrButton from '../buttons/OnTraccrButton';

export default function BulkSelectionHeader({
  selected = [],
  canArchive = false,
  canActivate = false,
  canDelete = false,
  deleteAllSelected = false,
  onArchive,
  onActivate,
  onDelete,
}) {
  const { archiveCount, activateCount, deleteCount } = useMemo(() => {
    let archive = 0;
    let activate = 0;
    let del = 0;
    selected.forEach((record) => {
      if (record.active) {
        archive += 1;
      } else {
        activate += 1;
        del += 1;
      }
    });
    if (deleteAllSelected) {
      del = selected.length;
    }
    return {
      archiveCount: archive,
      activateCount: activate,
      deleteCount: del,
    };
  }, [selected, deleteAllSelected]);

  const selectedModifier = selected.length === 1 ? '' : 's';

  const showArchive = canArchive && archiveCount > 0;
  const showActivate = canActivate && activateCount > 0;
  const showDelete = canDelete && deleteCount > 0;

  return (
    <Row justify="end" align="middle" gutter={14} style={{ minHeight: 32, marginBottom: 10 }}>
      <Col>
        Selected <b>{selected.length}</b> item{selectedModifier}
      </Col>
      {showArchive && (
        <Col style={{ paddingTop: 5 }}>
          <OnTraccrButton
            title={`Archive (${archiveCount})`}
            type="back"
            onClick={onArchive}
          />
        </Col>
      )}
      {showActivate && (
        <Col style={{ paddingTop: 5 }}>
          <OnTraccrButton
            title={`Activate (${activateCount})`}
            type="back"
            onClick={onActivate}
          />
        </Col>
      )}
      {showDelete && (
        <Col style={{ paddingTop: 5 }}>
          <OnTraccrButton
            title={`Delete (${deleteCount})`}
            type="back"
            icon={<DeleteOutlined />}
            onClick={onDelete}
          />
        </Col>
      )}
    </Row>
  );
}

BulkSelectionHeader.propTypes = {
  selected: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    active: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  })),
  canArchive: PropTypes.bool,
  canActivate: PropTypes.bool,
  canDelete: PropTypes.bool,
  deleteAllSelected: PropTypes.bool,
  onArchive: PropTypes.func,
  onActivate: PropTypes.func,
  onDelete: PropTypes.func,
};

BulkSelectionHeader.defaultProps = {
  selected: [],
  canArchive: false,
  canActivate: false,
  canDelete: false,
  deleteAllSelected: false,
  onArchive: null,
  onActivate: null,
  onDelete: null,
};
